export default "__VITE_ASSET__1acM94vp__ 720w";